import { Toast } from 'vant'
import '../styles/toast.css'
export function toast(options) {
  const def = {
    duration: 1500
  }
  if (typeof options === 'object') {
    options = Object.assign({}, def, options)
    Toast(options)
  } else {
    // Toast(Array.prototype.slice.apply(arguments))
    Toast(options)
  }
}
